import {customElement, property} from "lit/decorators.js";
import {html, type TemplateResult} from "lit";
import {UnLitElement} from "../../../common/elements";
import {Dialogs} from "./dialogs";
import {resolve} from "../../../container";
import {handleActivationKey} from "../../../common/utils/events";

@customElement("eop-inline-dialog-button")
export class EopInlineDialogButton extends UnLitElement {

    @property({attribute: "dialog-id"})
    public dialogId: string;
    @property()
    public label: string;
    @property({attribute: "style"})
    public buttonStyle: string;
    @property({attribute: "size"})
    public buttonSize: string;
    @property({attribute: "disabled-button", type: Boolean})
    public disabledButton: boolean = false;

    public constructor(private dialogs: Dialogs = resolve(Dialogs)) {
        super();
    }

    public render(): TemplateResult {
        return html`
            <button
                    class="uni-button ${this.buttonStyle} ${this.buttonSize}"
                    @click=${this.openDialog}
                    @keydown=${this.openDialogOnKeydown}
                    ?disabled=${this.disabledButton}
            >
                ${this.label}
            </button>
        `;
    }

    private openDialog(): void {
        void this.dialogs.open(this.dialogId);
    }

    private openDialogOnKeydown(e: KeyboardEvent): void {
        handleActivationKey(e, () => this.openDialog());
    }
}